// Home.xhr

(function () {
  window.Home = window.Home || {};

  function doRequest(method, url, data, headers) {
    const start = Date.now();
    data = data || {};
    headers = headers || {};
    headers['Content-type'] = headers['Content-type'] || 'application/json';
    headers.Accept = headers.Accept || 'application/json';
    headers.Authorization = headers.Authorization || 'Bearer ' + FS.User.sessionId;
    
    if(headers.Authorization == 'none') {
      delete headers.Authorization;
    }
    
    var headerList = [];
    Object.keys(headers).forEach(function(key) {
      headerList.push([key, headers[key]]);
    });
    
    return new Promise((resolve, reject) => {
      FS.xhr(method, encodeURI(url), headerList, JSON.stringify(data), function(xmlhttp) {
        Home.log({
          at: 'ajax',
          url,
          method,
          duration: Date.now() - start,
          status: xmlhttp.status
        });
        if (xmlhttp.status < 300) {
          if (xmlhttp.response) {
            xmlhttp.responseData = {};
            if (headers.Accept === 'application/json') {
              try {
                xmlhttp.responseData = JSON.parse(xmlhttp.response);
              } catch (e) {
                console.error(`Unable to parse JSON response from ${url}`);
                console.error(xmlhttp.response);
                xmlhttp.parseError = e;
              }
            }
          }
          resolve(xmlhttp);
        }
        else {
          reject(xmlhttp);
        }
      });
    });
  }
  
  function doGet(url, headers) {
    return doRequest('GET', url, null, headers);
  }
  
  function doPost(url, data, headers) {
    return doRequest('POST', url, data, headers);
  }
  
  function doPut(url, data, headers) {
    return doRequest('PUT', url, data, headers);
  }
  
  function doPatch(url, data, headers) {
    return doRequest('PATCH', url, data, headers);
  }

  function doDelete(url, headers) {
    return doRequest('DELETE', url, null, headers);
  }
  
  Home.xhr = {
    doRequest: doRequest,
    get: doGet,
    post: doPost,
    put: doPut,
    patch: doPatch,
    'delete': doDelete
  };

}());